import { render } from "./Recommend.vue?vue&type=template&id=3dd41598&ts=true"
import script from "./Recommend.vue?vue&type=script&lang=ts"
export * from "./Recommend.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__